export default {
    //RecordsList
    your_records: 'As suas gravações',
    loading_records: 'Carregamento de gravações...',
    project_name: 'Nome do curso',
    class_name: 'Nome da classe',
    participants: 'Participantes',
    total_size: 'Tamanho total',

}